import { render, staticRenderFns } from "./about-milestones.vue?vue&type=template&id=b7af71f8&scoped=true"
import script from "./about-milestones.vue?vue&type=script&lang=js"
export * from "./about-milestones.vue?vue&type=script&lang=js"
import style0 from "./about-milestones.vue?vue&type=style&index=0&id=b7af71f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7af71f8",
  null
  
)

export default component.exports